import React from 'react';
import parse from 'html-react-parser';
import styles from './styles.module.sass';

interface Props {
  intro?: string;
  content?: string;
  imageUrl?: string | false;
  imageUrl2?: string | false;
  imageUrl3?: string | false;
  imageUrl4?: string | false;
  imageUrl5?: string | false;
}

const Card: React.FC<Props> = ({
  intro = '',
  content = '',
  imageUrl = '',
  imageUrl2 = '',
  imageUrl3 = '',
  imageUrl4 = '',
  imageUrl5 = '',
}) => (
  <div className={styles.card}>
    {intro && <div className={styles.cardContent}>{parse(intro)}</div>}
    {imageUrl && <img src={imageUrl} alt="" />}
    {imageUrl2 && <img src={imageUrl2} alt="" />}
    {imageUrl3 && <img src={imageUrl3} alt="" />}
    {imageUrl4 && <img src={imageUrl4} alt="" />}
    {imageUrl5 && <img src={imageUrl5} alt="" />}
    {content && <div className={styles.cardContent}>{parse(content)}</div>}
  </div>
);

export default Card;
